import React, { useState } from "react";
import { clientShowEda, getProjectId } from "../../../../api/apiCallManager";
import { useMutation } from "@tanstack/react-query";
import { Modal } from "antd";
import { VscEye } from "react-icons/vsc";

// clientShowEda
function ShowClientEDA({ uploadedListData, componentIdentifier, edaResource }) {
  const [isModalVisible, setIsModalVisible] = useState(false); // State to control modal visibility
  const [edaData, setEdaData] = useState("");
  const mutation = useMutation({
    mutationFn: clientShowEda,
    onSuccess: (data) => {
      if (data.statusCode == 200) {
        setIsModalVisible(true);
        setEdaData(data);
      }
    },
  });

  const handleView = () => {
    setIsModalVisible(true);
    // if (componentIdentifier == "clientEda") {
    //   let payload = {
    //     bucketName: uploadedListData[0]?.bucketName,
    //     projectKey: uploadedListData[0]?.projectKey,
    //     event_type: "client_eda",
    //   };
    //   mutation.mutate(payload);
    // } else {
    //   let payload = {
    //     // bucketName: uploadedListData[0]?.bucketName,
    //     project_id: getProjectId(),
    //     projectKey: uploadedListData[0]?.projectKey,
    //     event_type: "final_eda",
    //   };
    //   mutation.mutate(payload);
    // }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div>
      <button onClick={handleView}>
        <VscEye color="#0057b8" size={15} />
      </button>
      {/* {JSON.stringify(uploadedListData, null, 4)} */}

      <Modal
        destroyOnClose={true}
        title="EDA"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        {/* {JSON.stringify(edaResource)} */}
        {/* {edaData?.body?.base64_image} */}
        {/* <img src={`data:image/png;base64,` + edaData?.body?.base64_image} /> */}

        <img src={`data:image/png;base64,` + edaResource} />
      </Modal>
    </div>
  );
}

export default ShowClientEDA;
